import { apiClient } from "./client";

export type AuditLog = {
  id: string;
  created_at: string;
  actor_user_id: string | null;
  actor_email: string | null;
  tenant_id: string | null;
  organization_id: string | null;
  action: string;
  resource_type: string | null;
  resource_id: string | null;
  payload: Record<string, unknown> | null;
  ip_address: string | null;
  user_agent: string | null;
};

export type AuditLogPage = {
  items: AuditLog[];
  total: number;
  limit: number;
  offset: number;
};

export type AuditLogFilters = {
  action?: string;
  actor_user_id?: string;
  organization_id?: string;
  resource_id?: string;
  from?: string;
  to?: string;
  q?: string;
  limit?: number;
  offset?: number;
};

export async function listAuditLogs(filters: AuditLogFilters = {}): Promise<AuditLogPage> {
  const { data } = await apiClient.get<AuditLogPage>("/api/v1/audit-logs", {
    params: filters,
  });
  return data;
}

export async function exportAuditLogsCsv(filters: AuditLogFilters = {}): Promise<Blob> {
  const { data } = await apiClient.get<Blob>("/api/v1/audit-logs/export.csv", {
    params: filters,
    responseType: "blob",
  });
  return data;
}
